<template>
  <Select :options="collectionOptions" :value="condition.value" @changeValue="store.commit(`${this.storeId}.value`, $event)" placeholder="Collection"></Select>
</template>

<script>
import DefaultValue from './DefaultValue.vue'
export default {
  extends: DefaultValue,
  computed: {
    collectionOptions() {
      return Object.entries(this.store.getter('collections') || []).reduce((result, [key, value]) => {
        result.push({
          id: key,
          text: value.label
        })
        return result
      }, [])
    }
  },
  methods: {
    //
  }
}
</script>
